import request from "@/utils/requestSC";

// 购物车列表
export async function getCart(params) {
  return request.get("/rest/cart/list", {
    params
  });
}

// 添加进货车
export async function addCart(params) {
  return request.post("/rest/cart/add", params);
}

// 删除进货车
export async function delCart(params) {
  return request({
    url: "/rest/cart/del",
    method: "post",
    params
  });
}

// 修改进货车数量
export async function editQuantity(params) {
  return request.post("/rest/cart/edit.quantity", params);
}

// 校验进货车
export async function submitVerify(params) {
  return request({
    url: "/rest/cart/submit.verify",
    method: "post",
    params
  });
}
